const statusColors = {
    Approved: '#01ae8f',
    Completed: '#01ae8f',
    Rejected: '#d0021b',
    DoNothing: '',
    Open: '#d66a00',
    NotStarted: '#d8d8dd',
    NotReady: '#d8d8dd',
    Canceled: '#5d6870',
    Skipped: '#5d6870',
    PendingExternalAction: '#ff9300'
}

export const getStatusColor = (status, defaultColor = '#d66a00') => {
    return Object.keys(statusColors).includes(status)
        ? statusColors[status]
        : defaultColor
}

export { default as ArrowIcon } from './ArrowIcon'
export { default as ApprovedIcon } from './ApprovedIcon'
export { default as InitiatedIcon } from './InitiatedIcon'
export { default as CompletedIcon } from './CompletedIcon'
export { default as ErrorIcon } from './ErrorIcon'
export { default as EscalatedIcon } from './EscalatedIcon'
export { default as DeferredIcon } from './DeferredIcon'
export { default as OpenIcon } from './OpenIcon'
export { default as NotStartedIcon } from './NotStartedIcon'
export { default as NotReadyIcon } from './NotReadyIcon'
export { default as LoaderIcon } from './LoaderIcon'
export { default as RejectedIcon } from './RejectedIcon'
export { default as CanceledIcon } from './CanceledIcon'
export { default as SkippedIcon } from './SkippedIcon'
export { default as PendingExternalActionIcon } from './PendingExternalAction'
